import { RxGlassesConfigurator } from "./configurator/configurator/RxGlassesConfigurator.js";
import { RxConfiguratorSlotsProvider, useRxConfiguratorSlots } from "./slots/slots/context.js";
import { SagaRegistry, ReducersRegistry } from "@grandvisionhq/state";
import prescriptionGlassesReducer from "./state/state/reducer.js";
import prescriptionGlassesSaga from "./state/state/sagas.js";
SagaRegistry.register("prescriptionGlasses", prescriptionGlassesSaga);
ReducersRegistry.register("prescriptionGlasses", prescriptionGlassesReducer);
export {
  RxConfiguratorSlotsProvider,
  RxGlassesConfigurator,
  useRxConfiguratorSlots
};
//# sourceMappingURL=index.js.map
